import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { notificationsApi } from "@/api";
import type { NotificationFilter } from "@/api";
import { QUERY_KEYS } from "@/constants";

/** Bildirishnomalarim ro'yxati (sahifalangan). */
export const useNotifications = (filter: NotificationFilter, enabled = true) =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_NOTIFICATIONS, filter],
    queryFn: () => notificationsApi.list(filter),
    enabled,
    placeholderData: keepPreviousData,
    select: res => ({ rows: res.data, meta: res.meta }),
  });

/** O'qilmaganlar soni — qo'ng'iroq yangi tursin deb vaqti-vaqti bilan so'raladi. */
export const useUnreadCount = () =>
  useQuery({
    queryKey: [QUERY_KEYS.GET_NOTIFICATIONS_UNREAD],
    queryFn: () => notificationsApi.unreadCount(),
    select: res => res.data.count,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });

const useInvalidateNotifications = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_NOTIFICATIONS] });
    queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GET_NOTIFICATIONS_UNREAD] });
  };
};

export const useMarkNotificationRead = () => {
  const invalidate = useInvalidateNotifications();
  return useMutation({
    mutationFn: (id: number) => notificationsApi.markRead(id),
    onSuccess: invalidate,
  });
};

export const useMarkAllNotificationsRead = () => {
  const invalidate = useInvalidateNotifications();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: invalidate,
  });
};
